import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../../firebase/firebaseConfig';
import { buildAuthPath } from '../../utils/authRoutes';
import { ROADMAP_PATHS } from '../Roadmap/roadmapPaths';
import LandingHeader from '../LandingPage/LandingHeader';
import './PricingPage.css';

const plansData = [
  {
    name: 'Essentials Plan',
    price: 'Free',
    period: '/month',
    description: 'Perfect for new coders and students',
    features: [
      'Unlimited code snippets',
      'Spaced repetition scheduling',
      'Basic analytics dashboard',
      'Email support',
      'Access to core study modes',
    ],
    cta: 'Get Started',
    to: ROADMAP_PATHS.menu,
    highlight: false,
    alwaysAuth: true,
  },
  {
    name: 'Pro Plan',
    price: '$7.99',
    period: '/month',
    description: 'Unlock all features and AI tools',
    features: [
      'Unlimited code snippets',
      'AI-powered snippet generation',
      'AI explanations for code',
      'Personalized review scheduling',
      'Priority email support',
      'All Upcoming Features',
    ],
    cta: 'Start Pro',
    highlight: true,
    gradient: true,
    alwaysAuth: false,
  },
  {
    name: 'Annual Pro',
    price: '~$5.58',
    period: '/month',
    description: 'Best value for committed learners',
    features: [
      'Everything in Pro, billed annually ($67.00/yr)',
      'Save 30% compared to monthly',
      '30-day money-back guarantee',
      'Priority support',
    ],
    cta: 'Go Annual',
    highlight: false,
    alwaysAuth: false,
  },
];

const PricingPage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
    });
    // Set initial state in case user is already logged in
    setIsLoggedIn(!!auth.currentUser);
    return () => unsubscribe();
  }, []);

  return (
    <>
      <LandingHeader />
      <div className="pricing-bg">
        <div className="pricing-container">
          <h1 className="pricing-main-title">Pricing that scales with your learning</h1>
          <div className="pricing-cards">
            {plansData.map((plan, idx) => {
              let to = plan.to;
              if (!plan.alwaysAuth && (plan.cta === 'Start Pro' || plan.cta === 'Go Annual')) {
                to = isLoggedIn ? '/subscription' : buildAuthPath({ from: 'landing' });
              }
              return (
                <div
                  key={plan.name}
                  className={`pricing-card${plan.highlight ? ' highlight' : ''}${plan.gradient ? ' gradient' : ''}`}
                >
                  <div className="pricing-card-header">
                    <h2>{plan.name}</h2>
                    <div className="pricing-card-price">
                      <span className="price">{plan.price}</span>
                      <span className="period">{plan.period}</span>
                    </div>
                    <div className="pricing-card-desc">{plan.description}</div>
                  </div>
                  <ul className="pricing-card-features">
                    {plan.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                  <Link to={to} className="pricing-card-cta">{plan.cta}</Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default PricingPage; 